import { QueryClient } from '@tanstack/vue-query'
import { toast } from 'vue-sonner'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: (failureCount, error) => {
        const status = error?.response?.status

        if (status && status >= 400 && status < 500) return false

        return failureCount < 2
      },
      refetchOnWindowFocus: false,
      refetchOnReconnect: 'always',
    },
    mutations: {
      onError: (error) => {
        const status = error?.response?.status
        if (status !== 401 && status !== 403) {
          const message = error?.response?.data?.message || 'Action failed. Please try again.'
          toast.error(message)
        }
      },
    },
  },
})
